const TEMPLATE_KEY_NUMERIC = /\{\{TEMPLATE_(\d+)\}\}/g;

/**
 * Returns the next `{{TEMPLATE_N}}` string after the highest N found in the given strings.
 * Empty or non-matching inputs yield `{{TEMPLATE_1}}`.
 *
 * @param {Array<string | null | undefined>} usedKeyStrings
 * @returns {string}
 */
export function suggestNextTemplateKey(usedKeyStrings) {
  let maxN = 0;

  for (const raw of usedKeyStrings) {
    if (raw == null || typeof raw !== 'string') {
      continue;
    }
    const s = raw.trim();
    if (!s) {
      continue;
    }
    const matches = s.matchAll(TEMPLATE_KEY_NUMERIC);
    for (const m of matches) {
      const n = parseInt(m[1], 10);
      if (!Number.isNaN(n)) {
        maxN = Math.max(maxN, n);
      }
    }
  }

  return `{{TEMPLATE_${maxN + 1}}}`;
}
